export const DEFAULT_TIME_ZONE = "Europe/Stockholm";

export const TIME_ZONE_COOKIE = "timeZone";

function isSupportedTimeZone(zone: string): boolean {
  if (!zone) return false;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: zone });
    return true;
  } catch {
    return false;
  }
}

export function normalizeTimeZone(zone: string | null | undefined): string {
  if (typeof zone !== "string") return DEFAULT_TIME_ZONE;
  const trimmed = zone.trim();
  if (!trimmed) return DEFAULT_TIME_ZONE;
  return isSupportedTimeZone(trimmed) ? trimmed : DEFAULT_TIME_ZONE;
}
